import _ from 'lodash';
import { determineErrorFromResponse, isStaticRender, isEpisode } from 'helpers/ContentHelper';
import { FETCH_VIDEO, FETCH_VIDEO_PANEL, CLEAR_VIDEO } from './VideoModalActions';
import { parseVideoResponse } from './VideoModalHelpers';

const INITIAL_STATE = {
  seo: null,
  errors: null,
  video: null,
  panelVideo: null,
  releaseUrl: null,
  isStatic: false,
};

export default function(state = INITIAL_STATE, action) {
  const errors = determineErrorFromResponse(action);
  switch (action.type) {
    case FETCH_VIDEO_PANEL: {
      const data = _.get(action, 'payload.data');
      const seo = _.get(data, 'SEO');
      const videoData = _.get(data, 'panels.member.0.items.member.0') || _.get(state, 'video');
      const videoType = _.get(videoData, 'videoType');
      const isFullEpisode = isEpisode(videoType);
      const panelVideo = videoData && { ...videoData, isFullEpisode, videoFormat: 'vod' };
      const nextState = {
        ...state,
        panelVideo,
        seo,
        errors,
        isStatic: isStaticRender(),
      };
      return nextState;
    }
    case FETCH_VIDEO: {
      const data = _.get(action, 'payload.data');
      const videoData = parseVideoResponse(data) || null;
      const videoType = _.get(videoData, 'videoType');
      const isFullEpisode = isEpisode(videoType);
      const video = videoData && { ...videoData, isFullEpisode, videoFormat: 'vod' };
      const releaseUrl = _.get(video, 'url', null);
      return {
        ...state,
        releaseUrl,
        errors,
        video,
      };
    }
    case CLEAR_VIDEO: {
      return {
        ...state,
        ...INITIAL_STATE,
      };
    }
    default:
      return state;
  }
}
